module.exports = __webpack_public_path__ + "acc1f0f3f8780f2e855bfcadf9fe68cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Prompt/PageStrandedPageOwner/svg/loudspeaker.svg
// module id = ./src/components/Prompt/PageStrandedPageOwner/svg/loudspeaker.svg
// module chunks = 4